import { render } from "./tablePlus.vue?vue&type=template&id=da0f8082&scoped=true"
import script from "./tablePlus.vue?vue&type=script&lang=js"
export * from "./tablePlus.vue?vue&type=script&lang=js"

import "./tablePlus.vue?vue&type=style&index=0&id=da0f8082&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da0f8082"]])

export default __exports__